import React from "react";
import { useTranslation } from "react-i18next";
import "./sustainability.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf, faHandHoldingHeart, faScaleBalanced, faFilePdf } from "@fortawesome/free-solid-svg-icons";

import imgESG from "../../imagens/ESG.jpg"; 

function Sustainability() {
    const { t, i18n } = useTranslation();

    // =========================================================
    // CONFIGURAÇÃO DOS PDFs
    // =========================================================
    // Certifique-se que estes arquivos estão na pasta: public/pdfs/
    const pdfPT = "/pdfs/PoliticaAmbiental.pdf"; // Nome exato do arquivo PT
    const pdfEN = "/pdfs/PoliticaAmbientalEn.pdf"; // Nome exato do arquivo EN

    // Lógica: Se o idioma for português (pt, pt-BR), usa o pdfPT, senão usa o pdfEN
    const currentPdf = i18n.language.startsWith('pt') ? pdfPT : pdfEN;

    return (
        <div className="container-fluid p-0">
            
            {/* HERO SECTION */}
            <section className="sustainability-hero d-flex align-items-center justify-content-center">
                <div className="text-center text-white p-4" style={{ backgroundColor: "rgba(20, 78, 153, 0.85)", borderRadius: "8px" }}>
                    <h1 className="fw-bold display-5">{t("sustainability.title")}</h1>
                    <p className="lead m-0">{t("sustainability.subtitle")}</p>
                </div>
            </section>

            <div className="container my-5 pt-4">
                
                {/* --- SEÇÃO DE INTRODUÇÃO --- */}
                <div className="intro-section-wrapper mb-5"> 
                    
                    {/* Área do Texto */}
                    <div className="intro-text-area">
                        <h2 className="bgColorCustom mb-3">{t("sustainability.introTitle")}</h2>
                        
                        <div className="intro-divider mb-4"></div>
                        
                        <p className="text-muted fs-5 small-text-justify mb-4">
                            {t("sustainability.introText")}
                        </p>

                        {/* --- BOTÃO DE DOWNLOAD DO PDF --- */}
                        {/* O href={currentPdf} faz o link funcionar dinamicamente */}
                        <div className="d-flex justify-content-center buttonEnvironment">
                            <a 
                                href={currentPdf} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="textEnvironment"
                                title={t("sustainability.downloadPolicy")}
                            >
                                <FontAwesomeIcon icon={faFilePdf} className="me-2 textEnvironment" />
                                {t("sustainability.downloadPolicy")}
                            </a>
                        </div>
                        {/* ------------------------------- */}

                    </div>

                    {/* Área da Imagem */}
                    <div className="intro-image-area">
                        <div className="sustainability-intro-image-wrapper shadow-sm border rounded p-2">
                            <img 
                                src={imgESG} 
                                alt={t("sustainability.introTitle")} 
                                className="img-fluid"
                            />
                        </div>
                    </div>
                </div>

                <hr className="my-5" style={{ color: "#144e99", opacity: 0.2 }} />

                {/* --- CARDS ESG --- */}
                <div className="esg-cards-container">
                    {/* E - Environmental */}
                    <div className="esg-card shadow-sm border rounded">
                        <div className="icon-wrapper mb-3 text-success">
                            <FontAwesomeIcon icon={faLeaf} size="3x" />
                        </div>
                        <h3 className="bgColorCustom h4">{t("sustainability.envTitle")}</h3>
                        <p className="text-muted mt-3 small-text-justify">
                            {t("sustainability.envText")}
                        </p>
                    </div>

                    {/* S - Social */}
                    <div className="esg-card shadow-sm border rounded">
                        <div className="icon-wrapper mb-3 text-danger">
                            <FontAwesomeIcon icon={faHandHoldingHeart} size="3x" />
                        </div>
                        <h3 className="bgColorCustom h4">{t("sustainability.socialTitle")}</h3>
                        <p className="text-muted mt-3 small-text-justify">
                            {t("sustainability.socialText")}
                        </p>
                    </div>

                    {/* G - Governance */}
                    <div className="esg-card shadow-sm border rounded">
                        <div className="icon-wrapper mb-3 text-primary">
                            <FontAwesomeIcon icon={faScaleBalanced} size="3x" />
                        </div>
                        <h3 className="bgColorCustom h4">{t("sustainability.govTitle")}</h3>
                        <p className="text-muted mt-3 small-text-justify">
                            {t("sustainability.govText")}
                        </p>
                    </div>
                </div>
                
                {/* CALL TO ACTION */}
                 <div className=" mt-5 pt-4">
                    <div className="col-12 text-center">
                        <div className="p-5 rounded" style={{ backgroundColor: "#f4f4f4", borderLeft: "5px solid #144e99", borderRight: "5px solid #144e99" }}>
                            <h4 className="bgColorCustom mb-3">{t("sustainability.commitmentTitle")}</h4>
                            <p className="m-0 text-dark">
                                {t("sustainability.commitmentText")}
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Sustainability;